import { LegalP, LegalH3 } from "@/components/sections/editorial/legal/post/parts";

export const ETHICS_INTRO = (
  <LegalP>
    Proxidize is committed to maintaining a responsible, transparent, and compliant approach to
    acquiring and operating IP resources. Our network is built on clear authorization, explicit
    consent, and secure participation standards that govern every IP incorporated into the Proxidize
    ecosystem. We maintain strict controls to ensure that all IPs entering the network are ethically
    sourced and lawfully used.
  </LegalP>
);

export const SECTIONS = [
  {
    id: "how-we-source-ips",
    heading: "How We Source IPs",
    content: (
      <>
        <LegalP>
          Proxidize sources IP resources through controlled, compliant, and consent-driven channels
          that operate under strict oversight. Our network includes managed cloud mobile and
          residential proxy resources operated and verified by Proxidize, as well as authorized
          partner-sourced IP resources that meet the same standards for consent, verification, and
          lawful availability.
        </LegalP>
        <LegalP>
          Every sourcing path must demonstrate transparent participation terms, clear legal
          authority to make network resources available, and responsible data handling practices.
          These paths are reviewed for compliance, authorization, and operational integrity before
          being accepted into the Proxidize network. Any channel that cannot meet Proxidize
          requirements is removed or denied.
        </LegalP>
        <LegalP>
          By combining dedicated infrastructure with approved, consent-based channels under a single
          governance model, Proxidize ensures a predictable, ethical, and scalable supply of IP
          resources. This unified sourcing framework provides consistent security, accountability,
          and transparency across the entire network.
        </LegalP>
      </>
    ),
  },
  {
    id: "security-and-compliance",
    heading: "Security and Compliance",
    content: (
      <>
        <LegalP>
          Proxidize implements strict security controls to protect network integrity and customer
          data. All systems are designed to prevent unauthorized access, ensure responsible usage,
          and maintain compliance with applicable requirements. Traffic is monitored for abnormal or
          prohibited activity, and any misuse results in immediate restriction or removal.
        </LegalP>
        <LegalP>
          We proactively enforce rules that prevent unethical or illegal activity across the
          network. Proxidize continually evaluates its controls to maintain a safe, trustworthy
          environment for all customers.
        </LegalP>
      </>
    ),
  },
  {
    id: "controlled-customer-onboarding",
    heading: "Controlled Customer Onboarding",
    content: (
      <>
        <LegalH3>Identity Verification</LegalH3>
        <LegalP>
          Customers must complete identity checks before they gain full access to the platform.
          Verification may include name, email, IP information, region, and device identifiers.
          Additional documentation may be required for compliance.
        </LegalP>
        <LegalP>
          Failure to complete verification results in limited or denied access. Verification
          protects the network and ensures responsible usage.
        </LegalP>

        <LegalH3>Usage Monitoring</LegalH3>
        <LegalP>
          Proxidize monitors traffic patterns to detect policy violations and to protect the
          network. All traffic is analyzed for abnormal activity. Non-compliant usage results in
          restriction or removal.
        </LegalP>
        <LegalP>
          Quality controls ensure that each IP remains safe and compliant. Traffic is logged for
          security and regulatory requirements.
        </LegalP>

        <LegalH3>Privacy Assurance</LegalH3>
        <LegalP>
          All operational data is encrypted and stored under strict access controls. Proxidize does
          not sell participant information or customer identification data. Information is disclosed
          only when legally required.
        </LegalP>
        <LegalP>
          Sensitive data is restricted to authorized personnel. Identity information of network
          operators and infrastructure staff is never shared.
        </LegalP>
      </>
    ),
  },
];
